import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { ActivEngageChat } from 'site-modules/shared/components/activ-engage-chat/activ-engage-chat';

export class ActivEngageChatBtn extends Component {
  componentDidMount() {
    this.chatController.init();
  }

  chatController = new ActivEngageChat({
    dealerWebSite: this.props.dealerWebSite,
    launchSource: this.props.launchSource,
    vehicleData: this.props.vehicleData,
  });

  handleStartChat = () => this.chatController.startChat();

  render() {
    return (
      <Button className="activ-engage-chat-btn small" color="primary" onClick={this.handleStartChat}>
        chat with dealer
      </Button>
    );
  }
}

ActivEngageChatBtn.propTypes = {
  dealerWebSite: PropTypes.string.isRequired,
  launchSource: PropTypes.string.isRequired,
  vehicleData: PropTypes.shape({
    vehicleMake: PropTypes.string,
    vehicleModel: PropTypes.string,
    vehicleStockNumber: PropTypes.string,
    vehicleVin: PropTypes.string,
    vehicleYear: PropTypes.string,
  }),
};

ActivEngageChatBtn.defaultProps = {
  vehicleData: {},
};
